/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useStaticQuery, graphql } from 'gatsby';

function Seo({ description, lang, meta, keywords, title, canonical, ogImage, twitterImage, type, pathName }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );

  const selectedPattern = `%s - ${site.siteMetadata.title}`;

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={selectedPattern}
      link={canonical ? [{ rel: 'canonical', key: canonical, href: canonical }] : []}
      meta={[
        {
          name: `title`,
          content: selectedPattern.replace('%s', title)
        },
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: selectedPattern.replace('%s', title)
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:type`,
          content: type ? type : `website`
        },
        {
          property: `og:locale`,
          content: `en_GB`
        },
        {
          property: `og:url`,
          content: `https://www.starlingbank.com${pathName}`
        },
        {
          property: `og:site_name`,
          content: `Starling Bank`
        },
        {
          property: `copyright`,
          content: `Starling Bank Limited`
        },
        {
          property: `HandheldFriendly`,
          content: `true`
        },
        {
          property: `apple-mobile-web-app-capable`,
          content: `yes`
        },
        {
          property: `mobile-web-app-capable`,
          content: `yes`
        },
        {
          property: `og:image`,
          content: ogImage
            ? `https://www.starlingbank.com${ogImage}`
            : 'https://www.starlingbank.com/media-library/default-share-img.jpg'
        },
        {
          property: `og:image:secure_url`,
          content: ogImage
            ? `https://www.starlingbank.com${ogImage}`
            : 'https://www.starlingbank.com/media-library/default-share-img.jpg'
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`
        },
        {
          name: `twitter:site`,
          content: `@starlingbank`
        },
        {
          name: `twitter:title`,
          content: selectedPattern.replace('%s', title)
        },
        {
          name: `twitter:image`,
          content: twitterImage
            ? `https://www.starlingbank.com${twitterImage}`
            : 'https://www.starlingbank.com/media-library/default-share-img.jpg'
        },
        {
          name: `twitter:description`,
          content: metaDescription
        },
        {
          property: `fb:app_id`,
          content: `376576989343149`
        }
      ]
        .concat(
          keywords.length > 0
            ? {
                name: `keywords`,
                content: keywords.join(`, `)
              }
            : []
        )
        .concat(meta)}
    />
  );
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired
};

export default Seo;
